export default "__VITE_ASSET__CADlfSa3__"